export default __webpack_public_path__ + "static/media/photos_4.e3897c83.jpg";